import {Component, OnInit} from '@angular/core';
import { HotelInfoUiService } from '../accommodation-info/services/hotel-info-ui.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  providers: [HotelInfoUiService],
  standalone: true,
   imports: [
      CommonModule,
       FormsModule,
       SharedModule,
  ]
})
export class CommentsComponent implements OnInit {
  reviewsCount = 0;
  stateCities: any[] = []
  breadcrumb = [
    {
      Url: '/',
      Name: 'صفحه اصلی',
      AriaCurrent: false
    },
    {
      Url: '',
      Name: 'نظرات',
      AriaCurrent: false
    }
  ]
  whiteBoxData: any[] = [
    {
      iconSource: 'assets/images/5488754.png',
      title: 'با ثبت رزرو شروع میشود',
      description: 'تنها راه برای ثبت نظر این است که هتل خود را رزرو کنید. از این طریق ما مطلع می شویم، نظراتی که ثبت می شود بوسیله ی میهمانان حقیقی است و آنها در واقعیت در هتل اقامت داشته اند'
    },
    {
      iconSource: 'assets/images/1379916.png',
      title: 'با سفر ادامه پیدا میکند',
      description: 'زمانی که میهمان در هتل اقامت دارد مواردی از جمله آرامش هتل و برخورد کارکنان هتل و ... را بررسی می کند.'
    },
    {
      iconSource: 'assets/images/3039617.png',
      title: 'و در نهایت ثبت نظر',
      description: 'بعد از سفر، میهمانان از اقامتشان برای ما می گویند و ما پس از ویرایش و اطمینان از صحت و اعتبار نظرات، آنها را روی وبسایت نمایش می دهیم'
    }
  ]
  latestReviews: any[] = []
  masonryData: any[] = []
  cities: any[] = []
  filteredMasonryData = this.masonryData

  // ---
  constructor(private websiteService: HotelInfoUiService) {
  }

  ngOnInit(): void {
    this.ReviewsCount()
    this.getStateCities()
    this.LatestReviews()
    this.topRateHotels()
    this.markedCities()
  }

  setCity(id: number) {
    this.inActiveCities()

    const index = this.cities.findIndex(city => city.Id === id)
    this.cities[index].IsActive = true

    this.setMasonryData(id)
  }

  filterData($event: any) {
    this.inActiveCities()
    const city = $event.target.value
    if (city) {
      const index = this.cities.findIndex(item => item.Title === city)
      if (index > 0) {
        this.setMasonryData(this.cities[index].Id)
      } else if (index === 0) {
        this.setMasonryData(-1)
      } else {
        this.setMasonryData(-2)
      }
    } else {
      this.setMasonryData(-1)
    }

  }

  inActiveCities() {
    for (let i = 0; i < this.cities.length; i++)
      this.cities[i].IsActive = false
  }

  setMasonryData(id: number) {
    if (id === -1) {
      this.filteredMasonryData = this.masonryData
      this.cities[0].IsActive = true

    } else if (id === -2) {
      this.filteredMasonryData = []

    } else {
      this.filteredMasonryData = this.masonryData.filter(item => item.CityID === id)
      const index = this.cities.findIndex(city => city.Id === +id)
      this.cities[index].IsActive = true
    }
  }

  ReviewsCount() {
    this.websiteService.getReviewsCount().subscribe(
      (response) => {
        this.reviewsCount = response
      }
    )
  }

  LatestReviews() {
    this.websiteService.getLatestReviews().subscribe(
      (response:any) => {
        this.latestReviews = response
      }
    )
  }

  topRateHotels() {
    this.websiteService.getTopRateHotels().subscribe(
      (response) => {
        this.masonryData = response
        this.filteredMasonryData = response
      }
    )
  }

  markedCities() {
    this.websiteService.getMarkedCities().subscribe(
      (response) => {
        this.cities = response
        this.inActiveCities()
        const allCity = {
          "Id": -1,
          "Title": "همه",
          "Marked": true,
          "IsActive": true,
          "EnTitle": "",
          "StateID": 0,
          "Latitude": 0,
          "Longitude": 0,
          "SearchOrder": 0,
          "DefaultReviewCount": 0,
          "NormalizedName": "",
          "cnt": 0
        }
        this.cities.unshift(allCity)
      }
    )
  }

  getStateCities() {
    this.websiteService.getStateCities().subscribe(
      (response) => {
        this.stateCities = response
      }
    )
  }
}
